import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Switch } from '../components/ui/switch';

export const NotificationPrefs = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get('/api/notifications/preferences').then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const save = (k, ch, v) => {
    api.put('/api/notifications/preferences', { prefs: { [k]: { [ch]: v } } }).then((r) => { setP(r.data); toast.success('Saved'); }).catch(() => toast.error('Could not save'));
  };
  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-2" data-testid="notification-prefs">
      <p className="text-sm font-medium">How we let you know</p>
      {(p.types || []).map((t) => (
        <div key={t.key} className="flex items-center gap-6 text-sm">
          <span className="w-56">{t.label}</span>
          <label className="flex items-center gap-2">In portal <Switch checked={t.in_app !== false} onCheckedChange={(v) => save(t.key, 'in_app', v)} data-testid={`pref-${t.key}-in_app`} /></label>
          <label className="flex items-center gap-2">Email <Switch checked={!!t.email} onCheckedChange={(v) => save(t.key, 'email', v)} data-testid={`pref-${t.key}-email`} /></label>
        </div>
      ))}
    </div>
  );
};

export default function ClientNotifications() {
  const [rows, setRows] = useState([]);
  const load = () => api.get('/api/notifications', { params: { limit: 100 } }).then((r) => setRows(Array.isArray(r.data) ? r.data : r.data.notifications || r.data.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const changed = () => { window.dispatchEvent(new Event('notifications:changed')); return load(); };
  const read = (id) => api.post(`/api/notifications/${id}/read`).then(changed);
  return (
    <div className="p-6 lg:p-10 space-y-8" data-testid="notifications-page">
      <div className="flex items-end justify-between">
        <h1 className="text-4xl sm:text-5xl font-headings font-bold">Notifications</h1>
        <Button variant="outline" onClick={() => api.post('/api/notifications/read-all').then(changed)} data-testid="notifications-read-all">Mark all read</Button>
      </div>
      <div className="rounded-xl border border-border divide-y divide-border bg-card">
        {rows.length === 0 && <p className="p-6 text-sm text-muted-foreground">No notifications.</p>}
        {rows.map((n) => (
          <div key={n.id} className="flex items-center gap-3 p-4" data-testid={`notification-${n.id}`}>
            {!n.read_at && <span className="w-2 h-2 rounded-full bg-primary" aria-label="Unread" />}
            <div className="min-w-0 flex-1">
              <Link to={n.link || '#'} onClick={() => read(n.id)} className="text-sm font-medium underline-offset-2 hover:underline">{n.title}</Link>
              <p className="text-xs text-muted-foreground truncate">{n.body} · {new Date(n.created_at).toLocaleString('en-AU')}</p>
            </div>
            {!n.read_at && <Button size="sm" variant="ghost" onClick={() => read(n.id)} data-testid={`notification-read-${n.id}`}>Mark read</Button>}
          </div>
        ))}
      </div>
      <NotificationPrefs />
    </div>
  );
}
